import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface GetVisitorCountsByClientRequest {
  buildingId?: number
  type: 'visitor' | 'guest' | 'vendor'
  search?: string
  filter?: string
  start?: number
  end?: number
  limit?: number
  skip?: number
}

interface VisitorCountByClient {
  clientId: number
  name: string
  count: number
}

export interface GetVisitorCountsByClientResponse {
  data: VisitorCountByClient[]
  total: number
  skip: number
  limit: number
  hasMore: boolean
}

export const VISITOR_COUNTS_BY_CLIENT_BASE_QUERY_KEY = 'useGetVisitorCountsByClient'
export const getVisitorCountsByClientQueryKey = (data: GetVisitorCountsByClientRequest) => [
  VISITOR_COUNTS_BY_CLIENT_BASE_QUERY_KEY,
  data,
]

export const getVisitorCountsByClient = async (
  params: GetVisitorCountsByClientRequest,
  signal?: AbortSignal,
): Promise<GetVisitorCountsByClientResponse> => {
  const { buildingId, ...rest } = params
  const response = await authAPI.get<GetVisitorCountsByClientResponse>(
    `/visitor/counts/${buildingId}/client`,
    {
      params: rest,
      signal,
    },
  )
  return response.data
}

export const useGetVisitorCountsByClient = (data: GetVisitorCountsByClientRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getVisitorCountsByClient(data, signal),
    queryKey: getVisitorCountsByClientQueryKey(data),
  })
}
